import { render, staticRenderFns } from "./Rename.vue?vue&type=template&id=2e932290&scoped=true&"
import script from "./Rename.vue?vue&type=script&lang=js&"
export * from "./Rename.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e932290",
  null
  
)

export default component.exports